//判断登陆状态  执行微信登陆
import axios from "axios";
import storageService from './storageService'
import AppSetting from './../../AppSetting'
import main from './../../main'
import Base64 from "./Base64";


function isWeixinBrowser() {
    /**
     * 是否时微信浏览器
     */
    var ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) == "micromessenger";
}

function isNotWeixinBrowser(){
    return !isWeixinBrowser();
}


function generateUUID (){
    var d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
    }
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
};

function saveSSOKey(userId,ssoKey)
{
    return new Promise((resolve, reject) => {
        axios.post(AppSetting.baseUrl + "/share-qrcode/saveSSOKey", {
            userId: userId,
            source: "MOBILE",// { PC:电脑端; MOBILE: 手机端 }
            ssoKey: ssoKey
        }).then(result => {
            if (result.data.code == 0 && result.data.data==true)  {
                resolve(true);
            } else {
                resolve(false);
            }
        })
        .catch(error=>{
            resolve(false);
        })
    })
}

function validateSSOKey(userId,ssoKey)
{
    return new Promise((resolve, reject) => {
        axios.post(AppSetting.baseUrl + "/share-qrcode/validateSSOKey", {
            userId: userId,
            source: "MOBILE",// { PC:电脑端; MOBILE: 手机端 }
            ssoKey: ssoKey
        }).then(result => {
            if (result.data.code == 0 && result.data.data==true)  {
                resolve(true);
            } else {
                // debugger
                main.vue.topTips("当前账号已经在其它设备登录! ")
                // alert("当前账号已经在其它设备登录!")
                resolve(false);
            }
        })
        .catch(error=>{
            main.vue.topTips("当前账号已经在其它设备登录! ")
            // alert("当前账号已经在其它设备登录!")
            resolve(false);
        })
    })
}


async function  setLoginUser(student) {
    /**
     * 1. 存储上登录信息
     * 2. 如果登录成功！ 要存储上单点登录的Key.
     */
    if(student && student!='null' && student!='undefined' && student.uId!=null && student.uId>0)
    {
        var userId=student.uId;
        var ssoKey =generateUUID()
        if(await saveSSOKey(userId,ssoKey))
        {
            //  存储上SSOKey数据。 
            storageService.setLoginDTO({
                ssoKey, // 存储上ssoKey
                student // 存储上 
            })
            return;
        }
    }
    // 登录失败，就退出登录
    storageService.logout();
}

async function getLoginUser() {
    // 获取到单点登录的数据。匹配不上就退出登录
    var loginDTO= storageService.getLoginDTO();

    if(loginDTO && loginDTO.student)
    {
        var student= loginDTO.student;
        var userId=loginDTO.student.uId;
        var ssoKey =loginDTO.ssoKey;

        if(ssoKey &&  await validateSSOKey(userId,ssoKey))
        {
            return student;
        }
    }

    // 登录失败，就退出登录
    storageService.logout();

    return null;
}


function logout(){
    storageService.logout();
}

async function isLogin() {
    var loginUser = await getLoginUser();
    return loginUser != null;
}

async function isNotLogin() {
    return (await isLogin())==false;
}

function login(router) {
    /**
     * 检验并且登录!
     */
    return new Promise(async (resolve, reject) => {
        var loginDTO =storageService.getLoginDTO()
        if (loginDTO) {
            // 已经登录，直接返回
            resolve(loginDTO.student)
        }
        else {
            // 
            redirectToWechat()
            .then(url=>{
                window.location.href=url;
            })
            .catch((error)=>{
                console.log("error >>> ",error)
                main.vue.topTips("微信登录失败(redirectToWechat)!")
            })
        }
    })
}


function getUserId()
{
    var loginDTO= storageService.getLoginDTO();
    if(loginDTO)
    {
        return loginDTO.student.uId;
    }
    return null;
}

function redirectToWechat(){
    /**
     * 跳转到微信登录
     * 1. 后台获取到跳转链接
     * 2. 直接页面跳转
     * 3. 微信登录成功后，会跳转到 /weixinlogin/code  进行根据code 获取用户信息
     */
    // 1. 后台获取到跳转链接

    return new Promise((resolve,reject)=>{
        var base= `${window.location.protocol}//${window.location.hostname}`;
        var routerBase= AppSetting.RouterBase;
        var redirectUri=`${base}/${routerBase}/weixinlogin/code`;

        console.log("redirectUri >>> ",redirectUri)
        var state=Base64.encode(window.location.href);    // 登录成功以后，跳转会回当前页面. 
        console.log("redirectUri >>> ",redirectUri)
        console.log("state >>> ",state)
        axios.post(AppSetting.baseUrl + "/weixin-login/getCodeUrl", {
            isWeixinBrowser: isWeixinBrowser(),  // 是否是微信浏览器
            redirectUri: redirectUri,  // 回调地址/
            state:state   // 
        }).then(result => {
            if (result.data.code == 0 && result.data.data)  {
                resolve(result.data.data)
            } else {
                reject()
            }
        })
        .catch(error=>{
            reject()
        })
    })
}


export default {
    isWeixinBrowser,
    isNotWeixinBrowser,
    isLogin,
    isNotLogin,
    login,
    getLoginUser,
    setLoginUser,
    logout,
    getUserId
};



// WEBPACK FOOTER //
// ./src/plugin/extendFn/loginService.js